import { motion, AnimatePresence } from "framer-motion";

export default function VirtualTourModal({
  open,
  onClose,
  title,
  rooms,
  activeRoom,
  setActiveRoom,
}) {
  if (!open) return null;

  return (
    <AnimatePresence>
      <motion.div
        className="fixed inset-0 z-50 bg-black/70 flex items-center justify-center px-4"
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        exit={{ opacity: 0 }}
      >
        <motion.div
          className="bg-white rounded-xl w-full max-w-7xl h-[80vh] flex flex-col overflow-hidden"
          initial={{ scale: 0.96 }}
          animate={{ scale: 1 }}
          exit={{ scale: 0.96 }}
        >
          {/* Header */}
          <div className="flex items-center justify-between px-6 py-4 border-b">
            <h3 className="font-semibold text-lg">{title}</h3>
            <button
              onClick={onClose}
              className="text-gray-500 hover:text-black"
            >
              ✕
            </button>
          </div>

          {/* Body */}
          <div className="flex flex-1 overflow-hidden">
            {/* Desktop Room Selector */}
            <aside className="hidden md:block w-64 border-r overflow-y-auto">
              {rooms.map((room, i) => (
                <button
                  key={i}
                  onClick={() => setActiveRoom(i)}
                  className={`w-full px-5 py-3 text-left text-sm border-b transition
                    ${
                      activeRoom === i
                        ? "bg-indigo-600 text-white"
                        : "hover:bg-gray-100"
                    }`}
                >
                  {room.label}
                </button>
              ))}
            </aside>

            {/* Viewer */}
            <div className="flex-1 relative">
              {/* Mobile selector */}
              <div className="md:hidden p-3 flex gap-2 overflow-x-auto border-b">
                {rooms.map((room, i) => (
                  <button
                    key={i}
                    onClick={() => setActiveRoom(i)}
                    className={`px-4 py-2 rounded-full text-sm whitespace-nowrap
                      ${
                        activeRoom === i
                          ? "bg-indigo-600 text-white"
                          : "bg-gray-200"
                      }`}
                  >
                    {room.label}
                  </button>
                ))}
              </div>

              {/* Iframe */}
              <iframe
                key={activeRoom}
                src={rooms[activeRoom].url}
                title={rooms[activeRoom].label}
                className="w-full h-full"
                allowFullScreen
                loading="lazy"
              />

              {/* Fallback */}
              <a
                href={rooms[activeRoom].url}
                target="_blank"
                rel="noopener noreferrer"
                className="absolute bottom-4 right-4 bg-white/90 backdrop-blur px-4 py-2 text-sm rounded-full shadow hover:bg-white"
              >
                Open in new tab →
              </a>
            </div>
          </div>
        </motion.div>
      </motion.div>
    </AnimatePresence>
  );
}
